module.exports = __webpack_public_path__ + "img/image2019-3-12_17_21_6.7b2aa5d7.png";